import { RootState } from "store";

const selectObjectPreviewData = (state: RootState) =>
  state.objectPreview.assignmentPreview;

export { selectObjectPreviewData };
